import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_img_placeholder = _resolveComponent("img-placeholder")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: ['el-skeleton__item', `el-skeleton__${_ctx.variant}`]
  }, _ctx.$attrs), [
    (_ctx.variant === 'image')
      ? (_openBlock(), _createBlock(_component_img_placeholder, { key: 0 }))
      : _createCommentVNode("", true)
  ], 16))
}